import { computed } from '@vue/composition-api'
import {
  map,
  groupBy,
  chain,
  each,
  get,
} from 'lodash'
import { CashRegisterTransactionHeaders, CashRegisterTransactionHeadersByType } from '@/utils/constants/table-headers'

// レジ締確定時に生成される過不足金 transaction の備考（バックエンドの
// CashRegister::ClosingFinalizer::OVER_SHORT_TRANSACTION_NOTE と一致させること）。
// この備考を持つ取引は入金/出金から分離し「過不足」タブにまとめる。
export const OVER_SHORT_NOTE = '過不足金（レジ締確定）'

export default cashRegisterTransactions => {
  const items = computed(() => {
    return map(cashRegisterTransactions.value, item => {
      let from = ''
      if (item.attributes.receiptId) {
        from = `伝票 No. ${item.attributes.receiptId}`
      } else if (item.attributes.benefitId) {
        from = item.meta.benefitLabelText
      } else if (item.attributes.expenseId) {
        from = item.meta.expenseLabelText
      } else if (item.attributes.balanceReceivableId) {
        from = item.meta.balanceReceivableText
      } else if (item.attributes.realMoneyProfitId) {
        from = '預金'
      }

      const note = item.attributes.note || ''

      const txTypeText = { deposit: '入金', withdraw: '出金' }[item.attributes.transactionType]

      return {
        ...item, from, note, txTypeText,
      }
    })
  })

  // 過不足金（レジ締確定）は note で判別し 'overShort' に振り分け、入金/出金から除外する。
  // それ以外は従来どおり transactionType（deposit/withdraw）でグルーピングする。
  const cashRegisterTransactionsByType = computed(() => {
    return groupBy(items.value, item => {
      if ((item.attributes.note || '') === OVER_SHORT_NOTE) return 'overShort'

      return item.attributes.transactionType
    })
  })

  const buildAllTransactionsXlsxData = () => {
    return chain(items.value)
      .map(o => {
        const data = {}

        each(CashRegisterTransactionHeaders, h => {
          const val = get(o, h.value)
          data[h.text] = Number.isNaN(Number(val)) ? val : Number(val)
        })

        return data
      })
      .value()
  }

  const buildDepositTransactionsXlsxData = () => {
    return chain(cashRegisterTransactionsByType.value.deposit)
      .map(o => {
        const data = {}

        each(CashRegisterTransactionHeadersByType, h => {
          const val = get(o, h.value)
          data[h.text] = Number.isNaN(Number(val)) ? val : Number(val)
        })

        return data
      })
      .value()
  }

  const buildWithdrawTransactionsXlsxData = () => {
    return chain(cashRegisterTransactionsByType.value.withdraw)
      .map(o => {
        const data = {}

        each(CashRegisterTransactionHeadersByType, h => {
          const val = get(o, h.value)
          data[h.text] = Number.isNaN(Number(val)) ? val : Number(val)
        })

        return data
      })
      .value()
  }

  // 過不足は余り(入金)・不足(出金)が混在するため、Txタイプ列を含む
  // CashRegisterTransactionHeaders を使って余り/不足を判別可能にする。
  const buildOverShortTransactionsXlsxData = () => {
    return chain(cashRegisterTransactionsByType.value.overShort)
      .map(o => {
        const data = {}

        each(CashRegisterTransactionHeaders, h => {
          const val = get(o, h.value)
          data[h.text] = Number.isNaN(Number(val)) ? val : Number(val)
        })

        return data
      })
      .value()
  }

  return {
    items,
    cashRegisterTransactionsByType,
    buildAllTransactionsXlsxData,
    buildDepositTransactionsXlsxData,
    buildWithdrawTransactionsXlsxData,
    buildOverShortTransactionsXlsxData,
  }
}
